import { useState } from "react";
import { shortPrincipal } from "../lib/utils";

type Props = { principal: string; full?: boolean };

export function CopyPrincipal({ principal, full = false }: Props) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    await navigator.clipboard.writeText(principal);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <button
      onClick={copy}
      title={principal}
      style={{
        background: "rgba(138,158,149,0.12)",
        border: "none",
        borderRadius: 4,
        color: copied ? "var(--color-accent)" : "var(--color-muted)",
        cursor: "pointer",
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        height: "auto",
        minHeight: "unset",
        padding: "3px 8px",
      }}
    >
      {copied ? "Copied!" : full ? principal : shortPrincipal(principal)}
    </button>
  );
}
